import { useState } from 'react';

export interface UsePropertyUIStateReturn {
  errors: any;
  setErrors: (errors: any) => void;
  clearErrorField: (fieldName: string) => void;

  disableButton: boolean;
  setDisableButton: (disabled: boolean) => void;

  sequence: any;
  setSequence: (value: any) => void;
}

export const usePropertyUIState = (): UsePropertyUIStateReturn => {
  const [errors, setErrorsState] = useState<any>({});
  const [disableButton, setDisableButtonState] = useState<boolean>(false);
  const [sequence, setSequenceState] = useState<any>({});

  const setErrors = (nextErrors: any): void => {
    setErrorsState(nextErrors);
  };

  const clearErrorField = (fieldName: string): void => {
    setErrorsState((previous: any) => ({ ...previous, [fieldName]: '' }));
  };

  const setDisableButton = (disabled: boolean): void => {
    setDisableButtonState(disabled);
  };

  const setSequence = (value: any): void => {
    setSequenceState(value);
  };

  return {
    errors,
    setErrors,
    clearErrorField,
    disableButton,
    setDisableButton,
    sequence,
    setSequence,
  };
};
